<template>
  <div class="zy-ad wow fadeInDown" :style="{
    backgroundImage: 'url(' + bg + ')',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat'
  }">
    <div class="zy-container">
      <h3 class="index-title">{{ title }}</h3>
      <p class="index-desc">{{ desc }}</p>
    </div>
    <slot></slot>

  </div>
</template>

<script>
import {WOW} from "wowjs";

export default {
  name: "Ad",
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  props: {
    title: String,
    desc: String,
    bg: Object,
  }
}
</script>

<style scoped lang="scss">
.zy-ad {
  //margin-top: 40px;
  margin-bottom: 40px;
  padding-top: 120px;
  padding-bottom: 120px;
}
.index-title {
  font-size: 32px;
  font-weight: 500;
  color: white;
}
.index-desc {
  font-size: 18px;;
  font-weight: 400;
  color: white;
  margin-top: 30px;
}
</style>
